import React from 'react';
import { CATEGORIES, categoryIcon, categoryAccentStyle } from '../lib/categories';

// Shared category filter chips: All plus the seven canonical categories.
export const CategoryChips = ({ value, onChange, idPrefix = 'filter' }) => (
  <div className="chip-row" role="group" aria-label="Filter by category" data-testid={`${idPrefix}-chips`}>
    <button
      type="button"
      className={`chip ${!value ? 'active' : ''}`}
      aria-pressed={!value}
      onClick={() => onChange('')}
      data-testid={`${idPrefix}-chip-all`}
    >
      All
    </button>
    {CATEGORIES.map((cat) => {
      const Icon = categoryIcon(cat);
      const active = value === cat;
      return (
        <button
          key={cat}
          type="button"
          className={`chip ${active ? 'active' : ''}`}
          style={categoryAccentStyle(cat)}
          aria-pressed={active}
          onClick={() => onChange(active ? '' : cat)}
          data-testid={`${idPrefix}-chip-${cat}`}
        >
          <Icon className="chip-icon" />
          {cat}
        </button>
      );
    })}
  </div>
);
